/* ADRO tweaks, loaded before adro-customiser.js so they apply before any preview renders:
   - larger example initials on the ADRO logo side
   - larger example logo on the customer logo side
   - brighter brushed stainless-steel finish for engraved artwork in the preview */
(function () {
  'use strict';
  var ctx = null;
  function measure(str, size) {
    if (!ctx) ctx = document.createElement('canvas').getContext('2d');
    ctx.font = '600 ' + size + 'px Inter, system-ui, -apple-system, sans-serif';
    return ctx.measureText(str).width + size * 0.06 * Math.max(0, str.length - 1);
  }

  // Repaint processed artwork (its alpha is the engraving mask) as bright brushed stainless steel.
  // Horizontal brushing, plus a soft vertical highlight band like light across a cylinder.
  function steelify(art) {
    return new Promise(function (res) {
      if (!art || !art.url) return res(art);
      var im = new Image();
      im.onload = function () {
        try {
          var w = im.naturalWidth, h = im.naturalHeight;
          var c = document.createElement('canvas'); c.width = w; c.height = h;
          var x = c.getContext('2d', { willReadFrequently: true });
          x.drawImage(im, 0, 0);
          var id = x.getImageData(0, 0, w, h), d = id.data;
          // per-row brushing streaks, smoothed so they read as fine lines rather than noise
          var rows = new Float32Array(h), seed = 1234567, prev = 0;
          for (var y = 0; y < h; y++) {
            seed = (seed * 1103515245 + 12345) & 0x7fffffff;
            var r = (seed / 0x7fffffff) - 0.5;
            prev = prev * 0.55 + r * 0.45; rows[y] = prev;
          }
          var cols = new Float32Array(w);
          for (var xx = 0; xx < w; xx++) {
            var t = xx / Math.max(1, w - 1);
            cols[xx] = 0.70
              + 0.30 * Math.exp(-Math.pow((t - 0.36) / 0.20, 2))
              + 0.10 * Math.exp(-Math.pow((t - 0.78) / 0.10, 2))
              - 0.10 * Math.pow(Math.abs(t - 0.5) * 2, 3);
          }
          for (var yy = 0; yy < h; yy++) {
            var streak = rows[yy] * 0.16;
            for (var x2 = 0; x2 < w; x2++) {
              var k = (yy * w + x2) * 4;
              if (!d[k + 3]) continue;
              var fine = (((x2 * 2654435761) ^ (yy * 40503)) & 255) / 255 * 0.035 - 0.0175;
              var v = cols[x2] + streak + fine;
              v = v < 0.42 ? 0.42 : (v > 1.04 ? 1.04 : v);
              var spec = v > 0.96 ? (v - 0.96) * 6 : 0; // hot highlight towards white
              d[k] = Math.min(255, v * 222 + spec * 40);
              d[k + 1] = Math.min(255, v * 228 + spec * 36);
              d[k + 2] = Math.min(255, v * 236 + spec * 30);
              d[k + 3] = Math.min(255, d[k + 3] * 1.02);
            }
          }
          x.putImageData(id, 0, 0);
          var out = {}; for (var key in art) out[key] = art[key];
          out.url = c.toDataURL('image/png');
          res(out);
        } catch (e) { res(art); }
      };
      im.onerror = function () { res(art); };
      im.src = art.url;
    });
  }
  function patch(K) {
    if (!K || !K.prototype || K.__adroTweaks) return;
    K.__adroTweaks = true;
    var P = K.prototype;
    if (typeof P.setArt === 'function') {
      var origSet = P.setArt;
      P.setArt = function (art) {
        var self = this;
        if (!art) return origSet.call(this, art);
        return steelify(art).then(function (a) { return origSet.call(self, a); });
      };
    }
    if (typeof P.makeExample === 'function') {
      var origEx = P.makeExample;
      P.makeExample = function () {
        var self = this;
        return Promise.resolve(origEx.apply(this, arguments)).then(function () {
          return steelify(self.example).then(function (a) { self.example = a; });
        });
      };
    }
    var orig = P.renderObjects;
    if (typeof orig !== 'function') return;
    P.renderObjects = function () {
      var out = orig.apply(this, arguments);
      try {
        var ex = this.exEl;
        if (ex) ex.style.opacity = '1';
        if (this.state && this.state.side === 'logo' && ex && !ex.hidden && this.example && this.exampleOn('logo')) {
          var la = this.area('logo'), asp = this.example.w / this.example.h;
          var ls = Math.min(la.w * 0.84, la.h * 0.62 * asp);
          this.applyBox(ex, this.box(la.x + la.w / 2 - ls / 2, la.y + la.h * 0.42 - ls / asp / 2, ls, ls / asp));
        }
        if (this.state && this.state.side === 'adro' && ex && !ex.hidden && this.exampleOn('adro')) {
          var span = ex.querySelector('.cz-obj__text');
          if (span && !span.hidden) {
            var t = this.cfg.exampleText || '', a = this.area('adro');
            var unit = measure(t, 10) / 10 || 1;
            var s = Math.max(15, Math.min(40, a.w * 0.62 / unit, a.h * 0.7));
            var w = measure(t, s) + s * 0.12, h = s * 1.2;
            this.applyBox(ex, this.box(a.x + a.w / 2 - w / 2, a.y + a.h * 0.5 - h / 2, w, h));
            span.style.fontSize = 'calc(var(--u) * ' + s.toFixed(3) + ')';
            // letter-spacing adds space after the last letter; balance it so the initials sit dead centre
            span.style.paddingLeft = '0.06em'; span.style.display = 'block'; span.style.textAlign = 'center';
          }
        }
      } catch (e) { /* keep the original preview if anything is missing */ }
      return out;
    };
  }
  if (window.AdroCustomiser) { patch(window.AdroCustomiser); return; }
  var held;
  Object.defineProperty(window, 'AdroCustomiser', {
    configurable: true, enumerable: true,
    get: function () { return held; },
    set: function (v) { held = v; patch(v); }
  });
})();
